import { dropNCharacters } from '~utils/string';

const mapActiveActions = (actions) => actions?.filter(({ active }) => active).map(({ action }) => action);

const PREFIX_LENGTH = 'api/v1/'.length;
export const mapToShort = (route) => dropNCharacters(PREFIX_LENGTH)(route);

const filterActivePolicies = (policies) =>
  policies?.filter(({ actions }) => actions.some(({ active }) => active));

export const userPoliciesMapper = (policies) =>
  filterActivePolicies(policies)?.map(({ actions, path }) => ({
    key: mapToShort(path),
    actions: mapActiveActions(actions)
  }));

export const getItem = (userPolicies, valuesArray) =>
  valuesArray.findIndex(({ policy }) => userPolicies?.some(({ path }) => mapToShort(path) === policy));
